import { render, staticRenderFns } from "./CustomsService.vue?vue&type=template&id=3f5fb53a&scoped=true&"
import script from "./CustomsService.vue?vue&type=script&lang=js&"
export * from "./CustomsService.vue?vue&type=script&lang=js&"
import style0 from "./CustomsService.vue?vue&type=style&index=0&id=3f5fb53a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5fb53a",
  null
  
)

export default component.exports